module.exports = __webpack_public_path__ + "img/horizontal_6_7_8017.d7ce1625.png";